export const GET_NOTIFICATION_FOR_WEBSITE_REQUEST =
  "GET_NOTIFICATION_FOR_WEBSITE_REQUEST";
export const GET_NOTIFICATION_FOR_WEBSITE_SUCCESS =
  "GET_NOTIFICATION_FOR_WEBSITE_SUCCESS";
export const GET_NOTIFICATION_FOR_WEBSITE_FAILURE =
  "GET_NOTIFICATION_FOR_WEBSITE_FAILURE";
